import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobService } from '../services/sections/job/job.service';

import { CustomerProposalItem } from '../models/proposal/proposal.model';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class CustomerProposalsResolver implements Resolve<Observable<CustomerProposalItem[]>> {

	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService
			.getCustomerProposals(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
